import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { ItemReferenceParams } from "@/types/itemReferenceTypes";
import { ParameterSubjectType } from "@/types/parameterTypes";
import { Parameter } from "@/backend/models/parameter";
import { Link, useLocation } from "react-router-dom";
import { BasicButton } from "../buttons/BasicButton";


export function ParameterSourceLink(props: { parameter: Parameter, reference?: ItemReferenceParams, setShow?: (show: boolean) => void }) {
  const { parameter, reference, setShow } = props;
  const enableReference = useParameterStore(state => state.enableReference);
  const link = useGetLink(parameter);

  const onResync = () => {
    if (reference) void enableReference(reference.id);
  };

  if (reference?.disabled) {
    return (
      <>
        {I18n.get('consumerManuallyEdited')}
        <Link to={link} aria-label={I18n.get('goToParameter')}>{I18n.get('sourceLowercase')}</Link>
        <BasicButton className='btn btn-sm py-0 link-primary' onClick={onResync} label={` (${I18n.get('resync')})`}/>
      </>
    );
  }

  return (
      <Link to={link} aria-label={I18n.get('goToParameter')} onClick={() => setShow?.(false)}>{I18n.get('viewSource')}</Link>
  );
}

function useGetLink(sourceParameter: Parameter) {
  const location = useLocation();
  const rootId = useTreeStore(state => state.rootId);
  const containerLookup = useTreeStore(state => state.containerLookup);
  const operations = useTreeStore(state => state.operations);

  if (location.pathname.includes('wizard')) {
    if (sourceParameter.subjectType === ParameterSubjectType.OPERATION) {
      const operation = operations.find(op => op.id === sourceParameter.subjectId);
      if (operation) {
        const scenario = containerLookup[operation.parentId];
        return `/procedures/wizard/${rootId}/steps/${scenario.parentId}#${sourceParameter.id}`;
      }
      return '';
    }
    return `/procedures/wizard/${rootId}/steps/${sourceParameter.subjectId}#${sourceParameter.id}`;
  }
  return `/procedures/run/${rootId}#${sourceParameter.id}`;
}
